import { z } from 'zod';

import { TransitGroup } from '@e-origin/shared';

export const TransitCreateDataSchema = z
  .object({
    name: z
      .string()
      .min(1, { message: 'Required' })
      .regex(/^[a-zA-Z0-9-]*$/g, { message: 'Name is invalid' }),
    customer: z.string().min(1, { message: 'Required' }),
    template: z.string().min(1, { message: 'Required' }),
    group: z.nativeEnum(TransitGroup),
    MRN: z.string().optional(),
  })
  .superRefine((data, ctx) => {
    if (data.group === TransitGroup.ARRIVAL && (!data.MRN || data.MRN.trim() === '')) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'Required',
        path: ['MRN'],
      });
    }
  });
export type TransitCreateData = z.infer<typeof TransitCreateDataSchema>;
